import templateUrl from "./edit-claim-permission-modal.component.html";

export const EditClaimPermissionModalComponent = {
    templateUrl,
    bindings: {
        resolve: "<",
        dismiss: "&",
        close: "&"
    },
    controller: class {
        constructor(permissionGrantService, utilityService) {
            'ngInject'
            this.permissionGrantService = permissionGrantService;
            this.utilityService = utilityService;
            this.isNew = true;
        }

        $onChanges() {
            if (this.resolve.permissionGrant && this.resolve.permissionGrant.Key) {
                // Prevent editing the permission.
                this.isNew = false;
            }

            this.claimType = this.resolve.claimType || null;
            this.claimValue = this.resolve.claimValue || null;
            this.permissionGrant = this.resolve.permissionGrant || {};
            this.permissionDescriptions = this.resolve.permissionDescriptions || [];
            this.permission = this.permissionDescriptions.find(p => this.permissionGrant.Key === p.Key);
        }

        onSave() {
            const saving = this.permissionGrantService
                .putClaimPermissionGrant(this.claimType, this.claimValue, this.permission.Key, {
                    Value: this.permissionGrant.Value
                });
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(saving, "Saving failed")
            )
            saving.then(() => {
                this.close({
                    $value: {
                        permissionGrant: {
                            Key: this.permission.Key,
                            Value: this.permissionGrant.Value
                        }
                    }
                });
            });
        }
    }
}
export const EditClaimPermissionModal = {
    component: "apexEditClaimPermissionModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
};
